export default __webpack_public_path__ + "static/media/dropdown_arrow.96b76ea1.svg";